/*
  Everlles 2026-09-28: description videos (<video autoplay muted loop playsinline> pasted into the
  product description) did not start on Samsung phones. Some mobile browsers ignore the autoplay
  attribute on videos that were hidden or offscreen at load (collapsed accordion, below the fold),
  and treat the HTML `muted` attribute as not yet muted. So: set the muted/playsInline properties
  in JS and call play() whenever a video scrolls into view. If the browser still refuses (power
  saving / data saver), show the native controls so the customer can start it with a tap.
*/
(function () {
  var SELECTOR = '.product__description video, .product__accordion video, .rte video';

  function prep(video) {
    if (video.dataset.evAutoplay) return;
    video.dataset.evAutoplay = '1';
    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    if (!video.hasAttribute('preload')) video.preload = 'metadata';
  }

  function tryPlay(video) {
    if (!video.paused) return;
    var p = video.play();
    if (p && typeof p.catch === 'function') {
      p.catch(function () {
        video.controls = true;
      });
    }
  }

  function init() {
    var videos = document.querySelectorAll(SELECTOR);
    if (!videos.length) return;
    var io =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (e) {
                if (e.isIntersecting) tryPlay(e.target);
              });
            },
            { threshold: 0.25 }
          )
        : null;
    videos.forEach(function (v) {
      prep(v);
      if (io) io.observe(v);
      else tryPlay(v);
    });
    // a video inside a collapsed accordion is not "intersecting" until the tab opens
    document.addEventListener('toggle', function (e) {
      if (!e.target.open) return;
      e.target.querySelectorAll('video').forEach(function (v) {
        prep(v);
        tryPlay(v);
      });
    }, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
